module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-contact"
  }, [(_vm.loading) ? _c('Loader') : _vm._e(), (_vm.props && !_vm.loading) ? _c('div', [_c('v-waypoint', {
    staticClass: "waypoint",
    on: {
      "waypoint-out": _vm.scrollOut,
      "waypoint-in": _vm.scrollIn
    }
  }), _c('PageHero', {
    attrs: {
      "props": _vm.props.acf.page_hero
    }
  }), _c('CustomHeader', {
    attrs: {
      "props": _vm.props.acf.custom_header
    }
  }), _c('div', {
    staticClass: "form_contact_outer"
  }, [_c('div', {
    staticClass: "form_btns_outer"
  }, [_c('div', {
    staticClass: "form_btnn"
  }, [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#existingform'),
      expression: "'#existingform'"
    }, {
      name: "if",
      rawName: "v-if:p",
      value: (_vm.props.acf.existing_patients_btn_text),
      expression: "props.acf.existing_patients_btn_text",
      arg: "p"
    }],
    attrs: {
      "id": "existformid",
      "href": "#",
      "onclick": "existopen()"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.existing_patients_btn_text)
    }
  })]), _c('div', {
    staticClass: "form_btnn"
  }, [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#newformm'),
      expression: "'#newformm'"
    }, {
      name: "if",
      rawName: "v-if:p",
      value: (_vm.props.acf.new_patients_btn_text),
      expression: "props.acf.new_patients_btn_text",
      arg: "p"
    }],
    attrs: {
      "id": "newformid",
      "href": "#",
      "onclick": "newopen()"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.new_patients_btn_text)
    }
  })])]), _c('div', {
    attrs: {
      "id": "existingform"
    }
  }, [_c('h3', {
    directives: [{
      name: "if",
      rawName: "v-if:p",
      value: (_vm.props.acf.existing_patients_form_title),
      expression: "props.acf.existing_patients_form_title",
      arg: "p"
    }],
    staticClass: "text-center",
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.existing_patients_form_title)
    }
  }), _c('Form')], 1), _c('div', {
    attrs: {
      "id": "newformm"
    }
  }, [_c('h3', {
    directives: [{
      name: "if",
      rawName: "v-if:p",
      value: (_vm.props.acf.new_patients_form_title),
      expression: "props.acf.new_patients_form_title",
      arg: "p"
    }],
    staticClass: "text-center",
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.new_patients_form_title)
    }
  }), _c('NewPatientForm')], 1)])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-11eddc40","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/pages/contact/contact.pug
// module id = 552
// module chunks = 1